import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const GridLayout = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 100%;
  max-width: 90.375rem;

  & > :not(:last-child) {
    margin-right: 1.5rem;
  }

  @media (max-width: 1740px) {
    max-width: 59.75rem;

    & > :not(:last-child) {
      margin-right: 0;
    }

    & > div:first-of-type {
      margin-right: 1.5rem;
    }
  }

  @media (max-width: 1245px) {
    max-width: 29.125rem;

    & > :not(:last-child) {
      margin-right: 0;
    }

    & > div:first-of-type {
      margin-right: 0rem;
    }
  }
`;
interface Props {
  children: ReactNode;
}

export const Grid = (props: Props) => {
  return (
    <Wrapper>
      <GridLayout>{props.children}</GridLayout>
    </Wrapper>
  );
};

export default Grid;
